/* RENEGADE · Swatches de color interactivos en tarjetas de producto (#6)
   <card-swatches> cambia la imagen de la tarjeta en sitio al elegir un color
   y reapunta los enlaces de la tarjeta a esa variante.
   Progressive enhancement: sin JS, cada swatch sigue siendo un <a> a la variante. */
if (!customElements.get('card-swatches')) {
  customElements.define(
    'card-swatches',
    class CardSwatches extends HTMLElement {
      connectedCallback() {
        this.card =
          this.closest('.card-custom_wrapp') ||
          this.closest('card-custom') ||
          this.closest('.product-card-wrapper');
        this.swatches = Array.from(this.querySelectorAll('[data-swatch]'));
        if (!this.card || this.swatches.length === 0) return;

        this.swatches.forEach((swatch) => {
          swatch.addEventListener('click', (event) => {
            // respeta abrir en pestaña nueva / clic central
            if (
              event.metaKey ||
              event.ctrlKey ||
              event.shiftKey ||
              event.altKey ||
              event.button === 1
            ) {
              return;
            }
            event.preventDefault();
            this.select(swatch);
          });
        });

        // Precarga las imágenes de cada color al primer hover/touch → cambio instantáneo
        this._prefetched = false;
        const prefetch = () => {
          if (this._prefetched) return;
          this._prefetched = true;
          this.swatches.forEach((s) => {
            const src = s.getAttribute('data-media-src');
            if (src) {
              const im = new Image();
              im.src = src;
            }
          });
        };
        this.addEventListener('pointerenter', prefetch);
        this.addEventListener('touchstart', prefetch, { passive: true });
      }

      get primaryImage() {
        return this.card.querySelector(
          '.card-custom--media .motion-reduce:not(.hover-image), .card-custom--media img:not(.hover-image), .card__media .media img.motion-reduce:first-of-type, .card__media .media img:first-of-type'
        );
      }

      get hoverImage() {
        return this.card.querySelector(
          '.card-custom--media .hover-image, .card__media .media img.motion-reduce:nth-of-type(2), .card__media .media img:nth-of-type(2)'
        );
      }

      setImage(src) {
        if (!src) return;
        const primary = this.primaryImage;
        if (primary) {
          primary.removeAttribute('srcset');
          primary.src = src;
        }
        // evita que el hover revele el otro color
        const hover = this.hoverImage;
        if (hover) {
          hover.removeAttribute('srcset');
          hover.src = src;
        }
      }

      select(swatch) {
        this.swatches.forEach((item) =>
          item.classList.toggle('is-active', item === swatch)
        );
        this.setImage(swatch.getAttribute('data-media-src'));

        const url = swatch.getAttribute('data-variant-url');
        if (url) {
          this.card
            .querySelectorAll('a[href]:not([data-swatch])')
            .forEach((link) => link.setAttribute('href', url));
        }
      }
    }
  );
}
